import { render, staticRenderFns } from "./BetInAcceptance.vue?vue&type=template&id=6f748d8d&scoped=true"
import script from "./BetInAcceptance.vue?vue&type=script&lang=ts"
export * from "./BetInAcceptance.vue?vue&type=script&lang=ts"
import style0 from "./BetInAcceptance.vue?vue&type=style&index=0&id=6f748d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f748d8d",
  null
  
)

export default component.exports